<!-- eslint-disable max-len -->
<template>
    <div id="main-container">
        <div class="top-menu flex-between-center" v-show="isShowTopMenu && !isShowLoading">
            <div class="flex-normal">
                <div class="logo hand" @click="handleGoHome"></div>
                <el-menu
                    data-test="el-menu"
                    class="flex-normal hidden-xs-only"
                    style="margin-left: 110px"
                    :default-active="menuItemkey"
                    menu-trigger="hover"
                    mode="horizontal"
                    background-color="#363e4f"
                    text-color="#c8cacf"
                >
                    <div data-class="router-link-custom-class" v-for="router in menuListFiltered" :key="router.router">
                        <router-link :to="router.router" v-if="!router.children">
                            <el-menu-item :index="router.router">
                                {{ router.name }}
                            </el-menu-item>
                        </router-link>

                        <el-submenu
                            :index="router.router"
                            popper-class="top-menu-popper"
                            class="sub-menu-con"
                            :class="menuItemkey === router.router ? 'active' : ''"
                            v-else
                        >
                            <template slot="title">
                                <router-link :to="router.router">
                                    {{ router.name }}
                                </router-link>
                            </template>

                            <div v-for="subRouter in router.children" :key="subRouter.router">
                                <router-link
                                    target="_blank"
                                    :to="{
                                        path: subRouter.router,
                                        params: subRouter.routerParams,
                                        query: subRouter.routerQuery,
                                    }"
                                    v-if="!subRouter.children"
                                >
                                    <el-menu-item :index="subRouter.router">
                                        <icon-svg class="f18 m-r-6" :icon-class="subRouter.icon"></icon-svg>
                                        {{ subRouter.name }}
                                    </el-menu-item>
                                </router-link>

                                <el-submenu
                                    :index="subRouter.router"
                                    class="last-sub-menu"
                                    popper-class="last-sub-menu-popper"
                                    v-else
                                >
                                    <template slot="title">
                                        <div @click="handleSelect(subRouter.routerName, subRouter)">
                                            <icon-svg class="f18 m-r-6" :icon-class="subRouter.icon"></icon-svg>
                                            {{ subRouter.name }}
                                            <i class="el-icon-arrow-right f14 arrow"></i>
                                        </div>
                                    </template>

                                    <el-menu-item
                                        v-for="lastRouter in subRouter.children"
                                        :key="lastRouter.router"
                                        :index="lastRouter.router"
                                    >
                                        <div @click="handleSelect(lastRouter.routerName, lastRouter)">
                                            {{ lastRouter.name }}
                                        </div>
                                    </el-menu-item>
                                </el-submenu>
                            </div>
                        </el-submenu>

                        <!-- 微前端特殊处理 -->
                        <ToolsHoverBox v-if="router.router === '/tools'" :key="isAgent" :configList="configList" />
                    </div>
                </el-menu>
                <!-- H5 -->
                <el-dropdown class="m-l-20 hidden-sm-and-up">
                    <i class="f24 el-icon-s-operation c-white"></i>

                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="menu in flatMenuList" :key="menu.value">
                            <router-link class="c-333" :to="menu.router">
                                {{ menu.name }}
                            </router-link>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <div class="flex-normal" id="main-topbar-right">
                <!-- <UploadingListPopover class="m-r-20" /> -->
                <dap-popover width="178" trigger="click" @show="handleShowDownload">
                    <div @click="handleDownload" slot="reference" class="m-r-20">
                        <span class="c-white hand">
                            <icon-svg class="f20" icon-class="yingyongtuiguang" />
                        </span>
                    </div>
                    <div class="download-App p-b-0">
                        <div id="dap-download"></div>
                        <div class="dap-download-text">扫一扫下载</div>
                    </div>
                </dap-popover>
                <div class="m-r-20" @click="toHelpCenterPage">
                    <span class="c-white hand">
                        <icon-svg class="f20" icon-class="bangzhuzhongxin" />
                    </span>
                </div>
                <!-- <el-button
                    class="pull-right m-r-30 f14 c-white"
                    type="text"
                    v-if="isMobile"
                    @click="handleSwitchToMobile()"
                >
                    切换至移动版
                </el-button> -->
                <template v-if="userInfo">
                    <div class="m-r-10 f14 c-white">{{ userInfo.name }}</div>

                <el-dropdown class="m-r-10" @command="handleCommand">
                    <div class="avatar hand">
                        <img
                            class="img-responsive"
                            v-if="!!userInfo.avatar"
                            :src="userInfo.avatar"
                            onerror="this.src='https://dapcdn.63cj.com/dap-web/assets/avatar.jpg'"
                        />
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item command="settings">设置</el-dropdown-item> -->
                        <el-dropdown-item command="logout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            </div>
        </div>

        <div v-if="isLoading && this.$route.name !== 'Login'" class="loading-animation">
            <div class="boxes">
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>

        <main id="app-viewport">
            <router-view></router-view>
            <!-- <HoverBtn
                v-if="!isLoading && $route.path !== '/login'"
                link="https://wenjuan.feishu.cn/m?t=saqFsZcylkMi-mal6"
            /> -->
        </main>
        <div id="subApp" class="m-t-60" style="overflow-y: auto"></div>
    </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import QRCode from 'qrcodejs2-fix';
import { loadIconfonts } from '@dap/helper';
import Util from '@dap/shared-utils';
import UtilCache from '@dap/shared-utils/cache';
import UtilDict from '@dap/shared-utils/dicts';
import { defaultDict } from '@dap/config';
// import Monitor from '@dap/monitor/sdk/index';
import ToolsHoverBox from '@dap/shared-views/src/tools/ToolsHoverBox.vue';
// import HoverBtn from '@dap/shared-views/src/home-v2/components/HoverBtn.vue';
// import UploadingListPopover from '@dap/shared-views/src/art-resource/components/UploadingListPopover.vue';
import customColumnService from '@dap/shared-api/common/customColumnService';
import CommService from '@dap/shared-api/common/commonService';

import config from '@dap/shared-views/src/tools/cardsList.js';
import logoImg from '@/assets/logo.png';

const downloadUrl = '/static/views/download.html';

export default {
    name: 'LayoutIndex',
    components: {
        ToolsHoverBox,
        // HoverBtn,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            userAuth: {},
            userName: '',
            downloadQR: '',

            clickCount: 0,
        };
    },

    computed: {
        canSeeMaterialList () {
            return !this.$store.getters.materialPermission;
        },
        menuList () {
            return [
                {
                    value: 'advertise-2',
                    name: '广告',
                    router: '/advertise-2',
                },
                {
                    value: 'table-2',
                    name:  '广告数据',//'工作表',
                    router: '/table-2',
                },
                {
                    value: 'observatory',
                    name: '观星台',
                    router: '/observatory',
                },
                {
                    value: 'creative-center',
                    name: '创意中心',
                    router: '/creative-center/dashboard',
                    routerName: 'creativeCenterDashboard',
                    children: [
                        {
                            icon: 'sucaiku',
                            name: '素材库',
                            routerName: 'material',
                            router: '/creative-center/material',
                            // 微前端改成计算属性，勿改
                            // hide: !UtilCache.getCacheWithChain('permissions.MaterialList'),
                            hide: this.canSeeMaterialList,
                            children: [
                                {
                                    name: '素材列表',
                                    router: '/creative-center/material/list',
                                    routerName: 'materialList',
                                    routerParams: {
                                        folderType: 'system',
                                        folderId: 0,
                                    },
                                    routerQuery: {
                                        gameId: Util.getLocalGameId(),
                                        regionId: +UtilCache.getCacheWithChain('filter.regionIds') || 1,
                                    },
                                },
                            ],
                        },
                        {
                            value: 'creative-library',
                            icon: 'chuangyiku',
                            name: '创意库',
                            router: '/creative-library',
                        },
                        {
                            value: 'script-manage-v2',
                            icon: 'jiaobenguanli',
                            name: '脚本创作',
                            router: '/creative-center/script-manage-v2',
                        },
                        {
                            value: 'script-project',
                            icon: 'gendanguanli',
                            name: '跟单中心',
                            router: '/creative-center/script-project',
                        },
                        {
                            value: 'producer',
                            icon: 'zhizuofangguanli',
                            name: '制作方',
                            router: '/creative-center/producer',
                        },
                    ].filter((i) => !i.hide),
                },
                {
                    value: 'art-resource',
                    name: '万花筒',
                    router: '/art-resource',
                },
                {
                    value: 'tools',
                    name: '工具库',
                    router: '/tools',
                },
            ];
        },
        menuListFiltered () {
            return this.menuList.filter((i) => i.name !== '观星台' || this.canSeeObservatory);
        },
        flatMenuList () {
            return this.menuListFiltered.reduce(
                (list, item) => (item.children ? [...list, item, ...item.children] : [...list, item]),
                []
            );
        },
        menuItemkey () {
            const path = this.$route.path.split('/')[1];
            // TODO Yo: AIGC放在工具库中的临时处理，后续要优化写法
            if (path === 'aigc') {
                return '/tools';
            }
            const checkRouter = this.menuListFiltered.find((i) => i.value === path);
            if (!checkRouter) {
                return '';
            }
            if (path === 'tool-list') {
                return 'Tools';
            }
            if (path === 'creative-library' || path === 'creative-center') {
                return 'creativeCenterDashboard';
            }
            return checkRouter.router;
        },
        userInfo () {
            // console.log('main userInfo', this.$store.getters.userInfo)
            return this.$store.getters.userInfo;
        },
        /**
         * warning Yo 微前端特殊处理， 勿改
         */
        canSeeObservatory () {
            return !!this.userInfo?.userAuth?.front_auth?.observatory?.menu.is_show;
        },

        isMobile () {
            return Util.isMobile();
        },

        isShowTopMenu () {
            return this.$route.name !== 'Login' && this.$route.name !== 'Table2DataGlobalH5';
        },
        isShowLoading () {
            return this.$route.name === 'Home' || this.$route.name === 'Advertise2';
        },
        dropdownActive () {
            return ['script-manage', 'creative-library', 'script-project'].includes(this.menuItemkey);
        },
        isAgent () {
            return this.userInfo?.isAgent;
        },
        configList () {
            const list = config;
            if (this.userInfo?.isAgent) list[list.length - 1].list.pop();
            return list;
        }
    },
    async mounted () {
        const token = UtilCache.getLocalItem('token');
        if (token) {
            this.initConfig();
        } else {
            Util.Bus.$on('loginDone', (done) => {
                if (done) {
                    this.initConfig();
                }
            });
        }
    },

    methods: {
        handleSelect (key, subRouter) {
            // console.log(key);
            const isOpenNewPage = ['material', 'materialList', 'creativeCenterDashboard'].includes(key);
            const routeObj = {
                name: key,
                // 跳转素材列表页需要默认值
                params: {
                    ...(key === 'materialList' ? {
                        folderType: 'system',
                        folderId: 0
                    } : {})
                },
                query: {
                    ...(key === 'materialList' ? {
                        gameId: Util.getLocalGameId(),
                        regionId: +UtilCache.getCacheWithChain('filter.regionIds') || 1,
                    } : {})
                },
            };

            if (isOpenNewPage) {
                let { href } = this.$router.resolve(routeObj);
                // waring Yo 素材列表页微前端特殊处理
                if (key === 'materialList' && !href.split('/')[0]) {
                    const { folderType, folderId } = routeObj.params;
                    href = `${subRouter.router}/${folderType}/${folderId}${href}`;
                } else {
                    href = subRouter.router;
                }
                window.open(href, '_blank');
            } else {
                this.$router.push(routeObj);
            }
        },

        handleGoHome () {
            // this.$router.push({ name: 'Advertise2' });
            // Warning YO 微前端特殊处理，勿改
            this.$router.push({ path: '/advertise-2' });

            this.clickCount++;
            if (this.clickCount === 5) {
                this.clickCount = 0; // 重置计数器

                MessageBox.confirm('是否清空本地缓存，重新登录？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        window.localStorage.clear();
                        window.location.reload();
                    })
                    .catch(() => {});
            }
        },

        getAuth () {
            if (UtilCache.getLocalItem('token')) {
                // LoginService.getAuthInfo().then(res => {
                //     UtilCache.setLocalItem('permissions', res.data.permissions);
                // });
            }
        },

        // 工作表的指标释义
        getColumnDescriptionV2 () {
            if (UtilCache.getCacheWithChain('baseConfig') && !UtilCache.getCacheWithChain('baseConfig.columnDefinition2')) {
                return customColumnService.getColumnDescriptionV2().then((res) => {
                    // 例 1: [1, 1, 1] = 指标id：[设备释义, 账号释义, 特殊释义]
                    UtilCache.setCacheWithChain('baseConfig.columnDefinition2', res.data.data);
                });
            }
            return null;
        },

        async getBaseConfig () {
            await UtilDict.getDict('baseConfig');
        },

        async setDefaultDict () {
            // for (const key of Object.keys(defaultDict)) {
            //     if (!UtilCache.getCacheWithChain(key)) {
            //         UtilCache.setCacheWithChain(key, defaultDict[key]);
            //     }
            // }
            Object.keys(defaultDict).forEach((key) => {
                if (!UtilCache.getCacheWithChain(key)) {
                    UtilCache.setCacheWithChain(key, defaultDict[key]);
                }
            });
        },
        async handleCommand (command) {
            if (command === 'settings') {
                this.$router.push({ name: 'Settings' });
            } else if (command === 'logout') {
                // 调用退出登录接口
                await CommService.logout();
                UtilCache.removeLocalAll();
                UtilCache.removeSessionAll();
                UtilCache.setLocalItem('from', this.$route.fullPath);
                this.$router.replace({ name: 'Login' });
                // warning YO 微前端特殊处理
                window.location.reload();
            }
        },
        // handleSwitchToMobile () {
        //     this.$router.replace({ name: 'Table2DataGlobalH5' });
        // },
        /**
         * Yo: 帮助中心跳转问题，勿改
         */
        toHelpCenterPage () {
            // const { href } = this.$router.resolve({
            //     name: 'HelpCenterHome',
            // });
            const { href } = this.$router.resolve({
                path: '/help-center/home',
            });
            window.open(href, '_blank');
        },

        handleDownload () {
            if (Util.isMobile()) {
                window.location.href = downloadUrl;
            }
        },
        handleShowDownload () {
            if (this.downloadQR) {
                return;
            }
            const downloadLink = `${window.location.protocol}//${window.location.host}${downloadUrl}?t=${+new Date()}`;
            const downloadEl = document.querySelector('#dap-download');
            let tmp = document.createElement('div');
            this.downloadQR = new QRCode(tmp, {
                text: downloadLink,
                width: 160,
                height: 160,
                colorDark: '#000000',
                colorLight: '#ffffff',
                useCanvas: true,
                correctLevel: QRCode.CorrectLevel.H,
            });
            let logo = new Image();
            logo.src = logoImg;
            logo.onload = () => {
                const qrImg = this.downloadQR._el.getElementsByTagName('img')[0];
                const canvas = this.downloadQR._el.getElementsByTagName('canvas')[0];
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#fff';
                this.roundRect(ctx, 160 * 0.5 - 24, 160 * 0.5 - 24, 48, 48, 4);
                ctx.fill();
                ctx.drawImage(logo, 160 * 0.5 - 14, 160 * 0.5 - 16.3, 28, 32.6);
                qrImg.src = canvas.toDataURL();
                downloadEl.appendChild(qrImg);
                // 销毁临时dom
                tmp = null;
                logo = null;
            };
        },
        roundRect (ctx, x, y, w, h, r) {
            const min_size = Math.min(w, h);
            if (r > min_size / 2) r = min_size / 2;
            // 开始绘制
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + w, y, x + w, y + h, r);
            ctx.arcTo(x + w, y + h, x, y + h, r);
            ctx.arcTo(x, y + h, x, y, r);
            ctx.arcTo(x, y, x + w, y, r);
            ctx.closePath();
            return ctx;
        },
        async initConfig () {
            const userInfo = UtilCache.getLocalItem('userInfo');
            const token = UtilCache.getLocalItem('token');
            const version = UtilCache.getLocalItem('version');
            if (userInfo) {
                this.$store.commit('SET_BASIC_STATE', {
                    key: 'userInfo',
                    value: userInfo,
                });
            }
            if (token) {
                this.$store.commit('SET_BASIC_STATE', {
                    key: 'token',
                    value: token,
                });
            }
            if (version) {
                this.$store.commit('SET_BASIC_STATE', {
                    key: 'version',
                    value: version,
                });
            }
            loadIconfonts();
            console.log(this.$route.path, '222from main');
            Promise.all([this.getBaseConfig(), this.setDefaultDict()]).then(() => {
                // 新版全局的指标释义
                this.getColumnDescriptionV2();

                // // init monitor dict
                // TODO YO 这个干嘛的这个？
                this.getAuth();
                this.redirectUrl();
                // console.log('this.$route.path 跳转前', this.$route.path);
                // Monitor.init();
                // console.log('this.$route.path 跳转后', this.$route.path);
            }).catch((errror) => {
                console.log('errror', errror);
            }).catch((error) => {
                console.log('errror', error);
            });
        },
        // init ads
        /**
         * warning Yo 微前端特殊处理，勿改
         */
        redirectUrl () {
            let fromName = UtilCache.getLocalItem('from');
            console.log('fromName', fromName, 'this.$route.path', this.$route.path);
            if (fromName === '/home' || fromName === '/') {
                fromName = '/advertise-2/home';
            }
            if (this.$route.path === '/home' || this.$route.path === '/advertise-2' || this.$route.path === '/') {
                if (fromName && fromName !== '/home') {
                    // console.error('我要跳了', fromName);
                    this.$router.replace({ path: fromName });
                    UtilCache.removeLocalItem('from');
                } else {
                    // this.$router.push({
                    //     name: this.isMobile ? 'Table2' : 'Advertise2',
                    // });
                    // warning YO 微前端特意处理，勿修改。否则无痕模式下不跳首页
                    this.$router.push({
                        path: this.isMobile ? '/table-2' : '/advertise-2/home',
                    });
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import '../../styles/var.scss';
.download-App {
    width: 178px;
    box-sizing: border-box;
    padding: 9px;
    .dap-download-text {
        text-align: center;
        color: #909399;
        font-size: 14px;
        padding-bottom: 7px;
        padding-top: 6px;
    }
}
.temporary-account {
    position: absolute;
    top: 20px;
    right: 200px;
}

.avatar {
    border-radius: 50%;
    overflow: hidden;
    background: url('https://dapcdn.63cj.com/dap-web/assets/avatar.jpg') no-repeat left top;
    background-size: cover;
}

.top-menu {
    background-color: $color-dark;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    z-index: 1000;

    .logo {
        width: 30px;
        height: 35px;
        margin-left: 20px;
        background: url('https://dapcdn.63cj.com/dap-web/assets/logo2.png') no-repeat left top;
        background-size: contain;
    }

    .el-menu.el-menu--horizontal {
        border-bottom: none;

        .el-menu-item {
            width: 80px;
            padding: 0;
            text-align: center;
            float: left;
            height: 60px;
            line-height: 60px;
            border-bottom: 4px solid #5ebfc9;
        }
        .el-menu-item.is-active {
            color: $color-white;
            border-bottom-color: #5ebfc9;

            &:hover,
            &:focus {
                color: $color-white;
            }
        }
        .menu-dropdown {
            @extend .el-menu-item;
            border-bottom-color: transparent;
            box-sizing: border-box;
            width: 100px;
            user-select: none;
            color: #c8cacf;

            &:hover {
                background-color: #262c37;
            }
        }
        .el-submenu__title {
            > a:visited,
            > a:link {
                color: #c8cacf;
            }
        }

        .el-submenu.active {
            .el-submenu__title {
                > a:visited,
                > a:link {
                    color: #fff;
                }
            }
        }

        .el-submenu.is-active .el-submenu__title {
            color: $color-white;
            border-bottom-color: #5ebfc9;
        }
    }

    .avatar {
        width: 40px;
        height: 40px;
    }
}

.home-menu-sub {
    .el-menu--popup {
        background-color: #fff !important;
        min-width: 120px;
        .el-menu-item {
            background-color: #fff !important;
            &:hover {
                background-color: #f1f1f2 !important;
            }
            a {
                color: #303133;
            }
        }
    }
}

$color: #5c8df6;
$colorRight: darken(#5c8df6, 15%);
$colorLeft: darken(#5c8df6, 5%);
$shadow: #dbe3f4;

.loading-animation {
    position: absolute;
    z-index: 100;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.boxes {
    --size: 32px;
    --duration: 800ms;
    height: calc(var(--size) * 2);
    width: calc(var(--size) * 3);
    position: relative;
    transform-style: preserve-3d;
    transform-origin: 50% 50%;
    margin-top: calc(var(--size) * 1.5 * -1);
    transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
    .box {
        width: var(--size);
        height: var(--size);
        top: 0;
        left: 0;
        position: absolute;
        transform-style: preserve-3d;
        &:nth-child(1) {
            transform: translate(100%, 0);
            animation: box1 var(--duration) linear infinite;
        }
        &:nth-child(2) {
            transform: translate(0, 100%);
            animation: box2 var(--duration) linear infinite;
        }
        &:nth-child(3) {
            transform: translate(100%, 100%);
            animation: box3 var(--duration) linear infinite;
        }
        &:nth-child(4) {
            transform: translate(200%, 0);
            animation: box4 var(--duration) linear infinite;
        }
        & > div {
            --background: #{$color};
            --top: auto;
            --right: auto;
            --bottom: auto;
            --left: auto;
            --translateZ: calc(var(--size) / 2);
            --rotateY: 0deg;
            --rotateX: 0deg;
            position: absolute;
            width: 100%;
            height: 100%;
            background: var(--background);
            top: var(--top);
            right: var(--right);
            bottom: var(--bottom);
            left: var(--left);
            transform: rotateY(var(--rotateY)) rotateX(var(--rotateX)) translateZ(var(--translateZ));
            &:nth-child(1) {
                --top: 0;
                --left: 0;
            }
            &:nth-child(2) {
                --background: #{$colorRight};
                --right: 0;
                --rotateY: 90deg;
            }
            &:nth-child(3) {
                --background: #{$colorLeft};
                --rotateX: -90deg;
            }
            &:nth-child(4) {
                --background: #{$shadow};
                --top: 0;
                --left: 0;
                --translateZ: calc(var(--size) * 3 * -1);
            }
        }
    }
}

@keyframes box1 {
    0%,
    50% {
        transform: translate(100%, 0);
    }
    100% {
        transform: translate(200%, 0);
    }
}

@keyframes box2 {
    0% {
        transform: translate(0, 100%);
    }
    50% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(100%, 0);
    }
}

@keyframes box3 {
    0%,
    50% {
        transform: translate(100%, 100%);
    }
    100% {
        transform: translate(0, 100%);
    }
}

@keyframes box4 {
    0% {
        transform: translate(200%, 0);
    }
    50% {
        transform: translate(200%, 100%);
    }
    100% {
        transform: translate(100%, 100%);
    }
}

[data-class='router-link-custom-class'] {
    @mixin tools-hover-box {
        box-sizing: border-box;
        position: fixed;
        z-index: 999999;
        top: 60px;
        left: 0;
        bottom: 0;
        right: 0;
        overflow: hidden;
        width: 100vw;
        min-width: 1366px;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        background: #ffffff;
        cursor: default;
        display: flex;
    }
    @mixin hover-out {
        height: 0;
        transition: height 0.1s 0 ease-out;
        // transition: height .3s .1s ease-out;
    }
    @mixin hover-in {
        height: 230px;
        transition: height 0.1s 0 ease-in;
        // transition: height .3s .1s ease-in;
    }
    .tools-hover-box-container {
        @include tools-hover-box;
        @include hover-out;
    }
    .tools-hover-box-container:hover {
        @include tools-hover-box;
        @include hover-in;
    }
    &:hover {
        .tools-hover-box-container {
            @include tools-hover-box;
            @include hover-in;
        }
    }
}

.home-filter-dropdown.el-popper[x-placement^='bottom'] {
    margin-top: 0px;
}

.top-menu-popper {
    .el-menu--popup {
        margin-top: 2px;
        min-width: 120px;
        background-color: #fff !important;
        border: 1px solid #ebeef5 !important;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        li,
        .el-submenu__title {
            background-color: #fff !important;
            color: #303133 !important;
            &:hover {
                background-color: #ecf3fe !important;
            }
            .el-menu-item {
                min-width: auto !important;
            }
        }
    }
}

.last-sub-menu-popper {
    margin-top: -6px;
    margin-left: 0;
    z-index: -2 !important;
    .el-menu--popup {
        margin: 0;
    }
}
</style>

<style lang="scss" scoped>
.sub-menu-con {
    width: auto !important;
    height: 60px;
    line-height: 60px !important;
    border-bottom: 4px solid transparent;
    box-sizing: border-box;
    &.active {
        border-bottom-color: #5ebfc9;
        ::v-deep .el-submenu__title {
            color: #fff !important;
        }
    }

    ::v-deep .el-submenu__title {
        line-height: 57px;
    }
}

::v-deep .el-submenu__icon-arrow {
    display: none;
}

.arrow {
    float: right;
    line-height: 36px;
    margin-right: -8px !important;
}

.home-top-repair{
    position: absolute;
    z-index: 1000;
    top: 20px;
    right: 240px;
}
</style>
